export enum FeatureFlags {
  AUTHENTICATE = 'authenticate',
  AUTO_ENABLE_NEXT = 'autoEnableNext',
  AUTOSAVE = 'autosave',
  CDN_ACTIVITIES = 'cdnActivities',
  CDN_ASSETS = 'cdnAssets',
  COMPONENT_TEST_PAGE = 'componentTestPage',
  CONTENT_TESTING = 'contentTesting',
  DEV_HOME_PAGE = 'devHomePage',
  DND_READ_ALOUD = 'dndReadAloud',
  EARLY_ACCESS = 'earlyAccess',
  ENABLE_ARBITRARY_LAUNCHING = 'enableArbitraryLaunching',
  ENABLE_LOGGING_SERVICE = 'enableLoggingService',
  ENABLE_SENTRY_LOGGING = 'enableSentryLogging',
  ENABLE_STUDENT_INBOX = 'enableStudentInbox',
  EXPANDABLE_CONTENT = 'expandableContent',
  EXPERIMENTAL_BROWSER = 'experimentalBrowser',
  FORCE_DISPLAY_ELAPSED_TIMER = 'forceDisplayElapsedTimer',
  FORCE_GRADE_3_PLUS_FLOW = 'forceGrade3PlusFlow',
  FORCE_PRE_K2_FLOW = 'forcePreK2Flow',
  KB_DEBUG = 'kbDebug',
  LIVE_CONTENT = 'liveContent',
  RANDOMIZE_ANSWER_CHOICES = 'randomizeAnswerChoices',
  REPLAY_BUTTON = 'replayButton',
  RETURN_TO_REFERRER = 'returnToReferrer',
  SANDBOX = 'sandbox',
  SAVE_ACTIVITY_ANYWHERE = 'saveActivityAnywhere',
  SAVE_DATA_FOLDER = 'saveDataFolder',
  SHOW_ACTIVITY_VERSION = 'showActivityVersion',
  SIGNAL_R_SERVICE = 'signalRService',
  SKIP_SPOT_SCENES = 'skipSpotScenes',
  TEACHER_MODE = 'teacherMode',
  USE_AMIRA_TTS = 'useAmiraTTS',
  USE_ASSIGNMENT_API = 'useAssignmentAPI',
  USE_CLICKSTREAM = 'useClickstream',
  USE_KB = 'useKB',
}
